import { render } from "./ProximoItemPicking.vue?vue&type=template&id=1ba2e68a&scoped=true"
import script from "./ProximoItemPicking.vue?vue&type=script&lang=js"
export * from "./ProximoItemPicking.vue?vue&type=script&lang=js"

import "./ProximoItemPicking.vue?vue&type=style&index=0&id=1ba2e68a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba2e68a"]])

export default __exports__